module.exports = [
	"Economy",
	"PremiumEconomy",
	"Business",
	"FirstClass"
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/static/fareClassType.json
// module id = 353
// module chunks = 0